import React, { useState } from "react";
import Icon from "components/AppIcon";

const CompanyFundamentals = ({ stock }) => {
  const [expanded, setExpanded] = useState(true);

  const metrics = [
    { label: "Market Cap", value: stock?.marketCap, icon: "DollarSign", color: "var(--color-primary)" },
    { label: "Revenue (TTM)", value: stock?.revenue, icon: "TrendingUp", color: "var(--color-success)" },
    { label: "Profit Margin", value: stock?.profitMargin, icon: "Percent", color: "var(--color-accent)" },
    { label: "P/E Ratio", value: stock?.peRatio, icon: "BarChart", color: "var(--color-primary)" },
    { label: "EPS", value: stock?.eps, icon: "Activity", color: "var(--color-success)" },
    { label: "52W High", value: stock?.high52w, icon: "ArrowUp", color: "var(--color-success)" },
    { label: "52W Low", value: stock?.low52w, icon: "ArrowDown", color: "var(--color-error)" },
    { label: "Avg Volume", value: stock?.avgVolume, icon: "BarChart2", color: "var(--color-muted-foreground)" },
  ];

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <button onClick={() => setExpanded(v => !v)}
        className="w-full flex items-center justify-between p-4 md:p-5 hover:bg-primary/5 transition-colors duration-150">
        <div className="flex items-center gap-2">
          <Icon name="Building2" size={16} color="var(--color-primary)" />
          <span className="font-heading text-sm font-semibold text-foreground">Company Fundamentals</span>
        </div>
        <Icon name={expanded ? "ChevronUp" : "ChevronDown"} size={16} color="var(--color-muted-foreground)" />
      </button>
      {expanded && (
        <div className="px-4 md:px-5 pb-4 md:pb-5">
          {/* Sector & Description */}
          <div className="flex flex-wrap items-center gap-2 mb-4">
            <span className="px-2.5 py-1 rounded-full text-xs font-caption font-medium border"
              style={{ background: "rgba(0,217,255,0.08)", borderColor: "rgba(0,217,255,0.25)", color: "var(--color-primary)" }}>
              {stock?.sector}
            </span>
            <span className="px-2.5 py-1 rounded-full text-xs font-caption border border-border text-muted-foreground">
              {stock?.exchange}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-4 leading-relaxed">{stock?.description}</p>

          {/* Metrics Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {metrics?.map(m => (
              <div key={m?.label} className="bg-secondary/60 rounded-lg p-3 border border-border/50">
                <div className="flex items-center gap-1.5 mb-1">
                  <Icon name={m?.icon} size={12} color={m?.color} />
                  <span className="text-xs text-muted-foreground font-caption">{m?.label}</span>
                </div>
                <div className="font-heading text-sm font-semibold text-foreground">{m?.value}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyFundamentals;